/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductQuoteOverrideViewModel
 */
export interface ProductQuoteOverrideViewModel {
    /**
     * 
     * @type {number}
     * @memberof ProductQuoteOverrideViewModel
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ProductQuoteOverrideViewModel
     */
    productQuoteId: number;
    /**
     * 
     * @type {Date}
     * @memberof ProductQuoteOverrideViewModel
     */
    dateCreated: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProductQuoteOverrideViewModel
     */
    modifiedDate: Date;
    /**
     * 
     * @type {number}
     * @memberof ProductQuoteOverrideViewModel
     */
    investmentAmount?: number;
    /**
     * 
     * @type {Date}
     * @memberof ProductQuoteOverrideViewModel
     */
    investmentPaymentDate?: Date;
}

/**
 * Check if a given object implements the ProductQuoteOverrideViewModel interface.
 */
export function instanceOfProductQuoteOverrideViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "productQuoteId" in value;
    isInstance = isInstance && "dateCreated" in value;
    isInstance = isInstance && "modifiedDate" in value;

    return isInstance;
}

export function ProductQuoteOverrideViewModelFromJSON(json: any): ProductQuoteOverrideViewModel {
    return ProductQuoteOverrideViewModelFromJSONTyped(json, false);
}

export function ProductQuoteOverrideViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductQuoteOverrideViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['Id'],
        'productQuoteId': json['ProductQuoteId'],
        'dateCreated': (new Date(json['DateCreated'])),
        'modifiedDate': (new Date(json['ModifiedDate'])),
        'investmentAmount': !exists(json, 'InvestmentAmount') ? undefined : json['InvestmentAmount'],
        'investmentPaymentDate': !exists(json, 'InvestmentPaymentDate') ? undefined : (new Date(json['InvestmentPaymentDate'])),
    };
}

export function ProductQuoteOverrideViewModelToJSON(value?: ProductQuoteOverrideViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'ProductQuoteId': value.productQuoteId,
        'DateCreated': (value.dateCreated.toISOString()),
        'ModifiedDate': (value.modifiedDate.toISOString()),
        'InvestmentAmount': value.investmentAmount,
        'InvestmentPaymentDate': value.investmentPaymentDate === undefined ? undefined : (value.investmentPaymentDate.toISOString()),
    };
}

